import { FC } from 'react'

import { ISvgClass } from '../interface'

const PeopleOutlineIcon: FC<ISvgClass> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 32 32"
      fill="none"
      {...props}
    >
      <path
        d="M22.0002 17.3327C20.4002 17.3327 17.9068 17.786 16.0002 18.666C14.0935 17.7727 11.6002 17.3327 10.0002 17.3327C7.10683 17.3327 1.3335 18.7727 1.3335 21.666V25.3327H30.6668V21.666C30.6668 18.7727 24.8935 17.3327 22.0002 17.3327ZM16.6668 23.3327H3.3335V21.666C3.3335 20.946 6.74683 19.3327 10.0002 19.3327C13.2535 19.3327 16.6668 20.946 16.6668 21.666V23.3327ZM28.6668 23.3327H18.6668V21.666C18.6668 21.0527 18.4002 20.5193 17.9735 20.0393C19.1468 19.6393 20.5868 19.3327 22.0002 19.3327C25.2535 19.3327 28.6668 20.946 28.6668 21.666V23.3327ZM10.0002 15.9993C12.5735 15.9993 14.6668 13.906 14.6668 11.3327C14.6668 8.75935 12.5735 6.66602 10.0002 6.66602C7.42683 6.66602 5.3335 8.75935 5.3335 11.3327C5.3335 13.906 7.42683 15.9993 10.0002 15.9993ZM10.0002 8.66602C11.4668 8.66602 12.6668 9.86602 12.6668 11.3327C12.6668 12.7993 11.4668 13.9993 10.0002 13.9993C8.5335 13.9993 7.3335 12.7993 7.3335 11.3327C7.3335 9.86602 8.5335 8.66602 10.0002 8.66602ZM22.0002 15.9993C24.5735 15.9993 26.6668 13.906 26.6668 11.3327C26.6668 8.75935 24.5735 6.66602 22.0002 6.66602C19.4268 6.66602 17.3335 8.75935 17.3335 11.3327C17.3335 13.906 19.4268 15.9993 22.0002 15.9993ZM22.0002 8.66602C23.4668 8.66602 24.6668 9.86602 24.6668 11.3327C24.6668 12.7993 23.4668 13.9993 22.0002 13.9993C20.5335 13.9993 19.3335 12.7993 19.3335 11.3327C19.3335 9.86602 20.5335 8.66602 22.0002 8.66602Z"
        fill="inherit"
      />
    </svg>
  )
}

export default PeopleOutlineIcon
